import styled from 'styled-components'

export const Navigation = styled.nav`
  display: flex;
  width: 100%;
  margin: 0 0 24px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderStrong};
  gap: clamp(18px, 2.5vw, 32px);
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: none;

  &::-webkit-scrollbar { display: none; }
`

export const NavigationButton = styled.button`
  position: relative;
  flex: 0 0 auto;
  min-height: 42px;
  padding: 0 1px 11px;
  border: 0;
  background: transparent;
  color: ${p => p.active ? p.theme.palette.colors.text : p.theme.palette.colors.muted};
  font: 700 14px/1.3 Lato, sans-serif;
  cursor: pointer;
  transition: color 0.2s ease;

  &::after {
    position: absolute;
    right: 0;
    bottom: -1px;
    left: 0;
    height: 2px;
    background: ${p => p.theme.palette.blue.main};
    content: '';
    transform: scaleX(${p => p.active ? 1 : 0});
    transform-origin: left;
    transition: transform 0.24s ease;
  }

  &:hover { color: ${p => p.theme.palette.colors.text}; }
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 5px; }
  @media (prefers-reduced-motion: reduce) { &, &::after { transition: none; } }
`
